import React from "react";
import { useMetaPixel } from "./components/MetaPixel";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/Hero";
import { Problems } from "./components/Problems";
import { Tomos } from "./components/Tomos";
import { Reviews } from "./components/Reviews";
import { Bonos } from "./components/Bonos";
import { Comparison } from "./components/Comparison";
import { Testimonials } from "./components/Testimonials";
import { Offer } from "./components/Offer";
import { Objections } from "./components/Objections";
export function App() {
  useMetaPixel();
  return <div className="min-h-full w-full bg-beige font-sans text-ink" data-id="element-0" data-mp="31ayvgg9eye65">
      <Hero data-id="element-1" data-mp="2wk06yte9u9rt" />
      <Problems data-id="element-2" data-mp="2wjgp1comflds" />
      <Tomos data-id="element-3" data-mp="2wiyxgtcwlvc7" />
      <Reviews data-id="element-4" data-mp="2wj8fnurpiy7c" />
      <Bonos data-id="element-5" data-mp="2wip6p3k1bk5g" />
      <Comparison data-id="element-6" data-mp="2wi5nljineppu" />
      <Testimonials data-id="element-7" data-mp="28u5zkrcq1dey" />
      <Offer data-id="element-8" data-mp="28tmej1rry8wp" />
      <Objections data-id="element-9" data-mp="28t4lsf4bmctj" />
      <PurchasePopup data-id="element-10" data-mp="28sl4n0mhvsgk" />
    </div>;
}